export default "__VITE_ASSET__05246248__"